import { TrendingUp, Zap, Receipt, PiggyBank, Banknote } from 'lucide-react'
import { computeDashboardMetrics } from '../../utils/dataHelpers'
import { formatNaira, formatNumber } from '../../utils/formatters'

function Card({ label, value, icon: Icon, iconColor, bgColor, textColor, fullWidthMobile }) {
  return (
    <div className={`rounded-xl shadow p-4 sm:p-5 ${bgColor || 'bg-white'} ${fullWidthMobile ? 'col-span-2 sm:col-span-1' : ''}`}>
      <div className="flex items-center justify-between mb-2">
        <p className={`text-xs sm:text-sm font-medium ${textColor || 'text-gray-500'}`}>{label}</p>
        <Icon className={`w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 ${iconColor}`} />
      </div>
      <p className={`text-lg sm:text-2xl font-bold ${textColor || 'text-gray-800'}`}>{value}</p>
    </div>
  )
}

export default function MetricCards({ currentUser, filters, branches, entries, expenses }) {
  const metrics = computeDashboardMetrics(currentUser, branches, entries, expenses, filters)

  const cards = [
    {
      label: 'Total Revenue',
      value: formatNaira(metrics.revenue),
      icon: TrendingUp,
      iconColor: 'text-green-500',
    },
    {
      label: 'Excess Profit',
      value: formatNaira(metrics.measuredExcessProfit),
      icon: Zap,
      iconColor: 'text-yellow-500',
    },
    {
      label: 'Total Expenses',
      value: formatNaira(metrics.totalExpenses),
      icon: Receipt,
      iconColor: 'text-red-500',
    },
    {
      label: 'Net Profit',
      value: formatNaira(metrics.netProfit),
      icon: PiggyBank,
      iconColor: 'text-purple-600',
    },
    {
      label: 'Amount to Remit',
      value: formatNaira(metrics.amountToRemit),
      icon: Banknote,
      iconColor: 'text-white',
      bgColor: 'bg-gradient-to-r from-green-500 to-green-600',
      textColor: 'text-white',
      fullWidthMobile: true,
    },
  ]

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Summary</h2>
        {metrics.entryCount > 0 && (
          <span className="text-xs text-gray-400">
            {formatNumber(metrics.entryCount)} {metrics.entryCount === 1 ? 'entry' : 'entries'}
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {cards.map((card) => (
          <Card key={card.label} {...card} />
        ))}
      </div>

      {metrics.entryCount === 0 && (
        <p className="text-center text-xs text-gray-400 py-1">No data for selected filters</p>
      )}
    </div>
  )
}
